const schemaOrgUrl = 'https://schema.org'

export const constructFaqJsonSchema = (
  faqs: { question: string; answer: string }[]
): LDJsonSchema => {
  return {
    '@context': schemaOrgUrl,
    '@type': 'FAQPage',
    mainEntity: faqs.map(faq => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer
      }
    }))
  }
}

export const constructJsonSchemaFromSeoString = (
  schema: string
): LDJsonSchema | null => {
  const jsonLDSchema: LDJsonSchema | undefined = JSON.parse(schema)
  const faqSchema = jsonLDSchema?.['@graph']
    ?.filter((item: LDJsonSchemaItem) => item['@type'] === 'Question')
    .map(item => {
      // converting wordpress url into peppercontent.io
      const url = (item['@id'] as string).replace(
        process.env.NEXT_PUBLIC_WORDPRESS_URL || '',
        'https://peppercontent.io/blog'
      )
      return { ...item, '@id': url }
    })

  if (faqSchema?.length !== undefined && faqSchema.length === 0) return null

  return {
    '@context': schemaOrgUrl,
    '@type': 'FAQPage',
    mainEntity: faqSchema
  }
}

export const constructBreadcrumbJsonSchema = (
  items: { name: string; url: string }[]
): LDJsonSchema => {
  const rootUrl = process.env.NEXT_PUBLIC_BASE_URL

  return {
    '@context': schemaOrgUrl,
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: `${rootUrl}${item.url}`
    }))
  }
}
